
export const FETCH_STARTED = 'FETCH_STARTED'
export const FETCH_DONE = 'FETCH_DONE'
export const CONTENT_FETCH_DONE = 'CONTENT_FETCH_DONE'
export const FETCH_FAILED = 'FETCH_FAILED'
export const SUBMIT_DONE = 'SUBMIT_DONE'
export const SUBMIT_FAILED = 'SUBMIT_FAILED'
export const LATEST_CONTENT_FETCH_DONE = 'LATEST_CONTENT_FETCH_DONE'
export const LATEST_CONTENT_FETCH_FAILED = 'LATEST_CONTENT_FETCH_FAILED'
export const SEARCH_STARTED = 'SEARCH_STARTED'
export const SEARCH_DONE = 'SEARCH_DONE'
export const SEARCH_FAILED = 'SEARCH_FAILED'
export const SEARCH_CAT_STARTED = 'SEARCH_CAT_STARTED'
export const SEARCH_CAT_DONE = 'SEARCH_CAT_DONE'
export const SEARCH_CAT_FAILED = 'SEARCH_CAT_FAILED'
export const SAVED_SEARCH_FETCH_DONE = 'SAVED_SEARCH_FETCH_DONE'
export const SAVED_SEARCH_FETCH_FAILED = 'SAVED_SEARCH_FETCH_FAILED'
export const SAVED_SEARCH_SUBMIT_DONE = 'SAVED_SEARCH_SUBMIT_DONE'
export const SAVED_SEARCH_SUBMIT_FAILED = 'SAVED_SEARCH_SUBMIT_FAILED'
export const FETCH_PDF_STARTED = 'FETCH_PDF_STARTED'
export const FETCH_PDF_DONE = 'FETCH_PDF_DONE'
export const FETCH_PDF_FAILED = 'FETCH_PDF_FAILED'
export const FETCH_CONFERENCE_STARTED = 'FETCH_CONFERENCE_STARTED'
export const FETCH_CONFERENCE_DONE = 'FETCH_CONFERENCE_DONE'
export const FETCH_CONFERENCE_FAILED = 'FETCH_CONFERENCE_FAILED'
export const IMPERSONATE_USER_STARTED = 'IMPERSONATE_USER_STARTED'
export const IMPERSONATE_USER_DONE = 'IMPERSONATE_USER_DONE'
export const IMPERSONATE_USER_FAILED = 'IMPERSONATE_USER_FAILED'
export const EMAIL_CONFIRMATION_STARTED = 'EMAIL_CONFIRMATION_STARTED'
export const EMAIL_CONFIRMATION_DONE = 'EMAIL_CONFIRMATION_DONE'
export const EMAIL_CONFIRMATION_FAILED = 'EMAIL_CONFIRMATION_FAILED'
